import { commit, commitOnePage } from "../../Actions/paymentActions";
import * as types from "../../Actions/actionTypes";

export const isItReal = (type, id) => {
  if (type === "ga") {
    if (id.length < 5 || !id.startsWith("UA-")) {
      return false;
    }
    return true;
  } else if (type === "pixel") {
    if (id.length < 5 || id.startsWith("xxx") || id.startsWith("XXX")) {
      return false;
    }
    return true;
  }
  return true;
};

export const getResponsible = (responsible) => {
  return {
    id: responsible.id,
    firstName: responsible.firstName,
    lastName: responsible.lastName,
    email: responsible.email,
    civicRegistrationNumber: responsible.civicRegistrationNumber,
    phoneNumbers: [
      {
        type: "Cell",
        number: responsible.cellPhone,
      },
    ],
    addresses: [
      {
        type: "Generic",
        street: responsible.street,
        streetNumber: responsible.streetNumber,
        zipCode: responsible.zipCode,
        city: responsible.city,
        countryCode: responsible.countryCode,
      },
    ],
  };
};

export const commitPurchase = (
  apiUri,
  saleId,
  supportsOnePage,
  setIsOnePageCheckoutActive,
  rdxDispatch,
  commitData,
  setAwaitingSwish
) => {
  const callBack = (status) => {
    console.log("paying...", status);
    if (status === "GiftCertificateIsEmpty") {
      rdxDispatch({
        type: types.ERROR,
        payload: "Förbrukat presentkort",
      });
    }
  };
  const externalPaymentSuccessCb = () => {
    setIsOnePageCheckoutActive(false);
    setAwaitingSwish && setAwaitingSwish(false);
  };
  const onePageSuccessCb = () => {
    setIsOnePageCheckoutActive(true);
    setAwaitingSwish && setAwaitingSwish(false);
  };

  const commitUri = `${apiUri}/sales/${saleId}/commit`;
  const commitOnePageUri = `${apiUri}/sales/${saleId}/onepage/commit`;

  if (supportsOnePage) {
    rdxDispatch(
      commitOnePage(commitData, commitOnePageUri, onePageSuccessCb, callBack)
    );
  } else {
    rdxDispatch(
      commit(commitData, commitUri, externalPaymentSuccessCb, callBack)
    );
  }
};
